import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-template",
  "use": "icon-template-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-template\"><path d=\"M294.912 414.208h86.528v342.016H294.912zM424.96 414.208h303.104v342.016H424.96zM294.912 267.264h433.152v97.792H294.912z\" p-id=\"4033\" /><path d=\"M921.6 0H102.4a102.4 102.4 0 0 0-102.4 102.4v819.2a102.4 102.4 0 0 0 102.4 102.4h819.2a102.4 102.4 0 0 0 102.4-102.4V102.4a102.4 102.4 0 0 0-102.4-102.4z m-150.016 780.8a23.04 23.04 0 0 1-21.504 24.064H273.408a23.04 23.04 0 0 1-21.504-24.064V242.688a23.04 23.04 0 0 1 21.504-24.064h476.672a23.04 23.04 0 0 1 21.504 24.064z\" p-id=\"4034\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/template.svg
// module id = //Qc
// module chunks = 29